import { render, staticRenderFns } from "./HiloButton.vue?vue&type=template&id=aefea86a"
import script from "./HiloButton.vue?vue&type=script&lang=js"
export * from "./HiloButton.vue?vue&type=script&lang=js"
import style0 from "./HiloButton.vue?vue&type=style&index=0&id=aefea86a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports